import { Flag } from 'lucide-react';
import { SessionFlaggedEvent as SessionFlaggedEventType } from '../types';
import EventShell from './EventShell';
import { BAN_LABELS, categoryLabel } from '../../sessions/moderation';

interface Props {
  event: SessionFlaggedEventType;
}

export default function SessionFlaggedEvent({ event }: Props) {
  const { payload } = event;
  const ban = payload.ban || 'none';
  return (
    <EventShell
      color="orange"
      icon={<Flag className="w-3.5 h-3.5" />}
      title={payload.verdict === 'unclear' ? 'Session Flagged (unclear)' : 'Session Flagged'}
      timestamp={event.created_at}
    >
      <p>{categoryLabel(payload.category)}</p>
      {payload.summary && <p>{payload.summary}</p>}
      <p>{BAN_LABELS[ban] || BAN_LABELS.none}</p>
    </EventShell>
  );
}
